import styled, { borderRadius, spacing } from "@rentiohq/web-theme";

// Below this width the slide text and its screenshot stack.
const TWO_COLUMN_MIN_WIDTH = "1000px";
// Keeps the slide the same height while paging, so the buttons do not jump.
const SLIDE_MIN_HEIGHT = "480px";
// Portrait screenshots stretched over the column would tower over the text.
const SLIDE_MEDIA_MAX_HEIGHT = "420px";

export const Slide = styled.div<{ hasMedia: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing("extraLoose")};
  align-items: center;
  min-height: ${SLIDE_MIN_HEIGHT};
  padding: ${spacing("extraLoose")};
  border-radius: ${borderRadius("large")};
  border: 1px solid ${({ theme }) => theme.colors.neutral30};
  background: ${({ theme }) => theme.colors.neutral0};

  @media (min-width: ${TWO_COLUMN_MIN_WIDTH}) {
    grid-template-columns: ${({ hasMedia }) =>
      hasMedia ? "minmax(0, 1fr) minmax(0, 1fr)" : "minmax(0, 1fr)"};
  }
`;

export const SlideText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing("base")};
`;

export const SlideLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.getColor("primary")};
`;

export const SlideTitle = styled.h2`
  margin: 0;
  font-size: 30px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.neutral100};
`;

// The academy text sets its own color and size; a slide reads larger.
export const SlideBody = styled.div`
  font-size: 18px;

  & > div {
    font-size: inherit;
  }
`;

// Shrinks the frame around the capped screenshot, centered in its column.
export const SlideMedia = styled.div`
  display: flex;
  justify-content: center;
  min-width: 0;

  & > * {
    width: auto;
  }

  & img,
  & video {
    width: auto;
    max-width: 100%;
    max-height: ${SLIDE_MEDIA_MAX_HEIGHT};
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing("base")};
  margin-top: ${spacing("loose")};
`;

export const Counter = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral70};
`;
